import React from 'react'
import { Product } from '../../../../modules/productsListing/reducer'
import { PrivateOfferPlans } from './PrivateOfferPlans/PrivateOfferPlans'
import { ServiceAgreement } from './ServiceAgreement/ServiceAgreement'
import { DetailsGCP } from './Details/DetailsGCP'
import { RenewalGCP } from '@labrav/marketplace'
import { FormikProps, useFormikContext } from 'formik'
import { PrivateOffer } from '../../../../modules/privateOffer/reducer'

export type PrivateOfferAddEditProps = {
  product: Product
  externalBaseURL?: string
  selectedEulaFiles: File[]
  setSelectedEulaFiles: (files: File[]) => void
}

export const PrivateOfferAddEdit: React.FC<PrivateOfferAddEditProps> = ({
  product,
  externalBaseURL,
  selectedEulaFiles,
  setSelectedEulaFiles,
}) => {
  const { values, setFieldValue } =
    useFormikContext() as FormikProps<PrivateOffer>
  return (
    <>
      <DetailsGCP product={product} externalBaseURL={externalBaseURL} />
      <PrivateOfferPlans product={product} />
      <RenewalGCP
        handleDetailsChange={data => {
          setFieldValue(data.key, data.value)
        }}
        channel={values.dealType || null}
      />
      <ServiceAgreement
        selectedEulaFiles={selectedEulaFiles}
        setSelectedEulaFiles={setSelectedEulaFiles}
      />
    </>
  )
}
